export default "__VITE_ASSET__Chg6H9nS__"